import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import { URL } from "../../api.jsx";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

const WalletTopUpRequest = () => {

  /* ===================== STATES ===================== */
  const [requests, setRequests] = useState([]);
  const [branchDropdown, setBranchDropdown] = useState([]);

  const [branchFilter, setBranchFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const [rejectModal, setRejectModal] = useState(false);
  const [rejectRemarks, setRejectRemarks] = useState("");
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedRequestType, setSelectedRequestType] = useState(null);

  const companyCode = localStorage.getItem("companyCode");
  const userId = localStorage.getItem("userId");

  /* ===================== FETCH BRANCH DROPDOWN ===================== */
  const fetchBranches = async () => {
    try {
      const res = await axiosInstance.get(URL.COMPANY_BRANCH);
      setBranchDropdown(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Branch dropdown error:", err);
      setBranchDropdown([]);
    }
  };

  /* ===================== GET BRANCH NAME ===================== */
  const getBranchName = (branchCode) => {
    const branch = branchDropdown.find(
      (b) => b.branchCode === branchCode && b.companyCode == companyCode
    );
    return branch ? branch.branchName : "-";
  };

  /* ===================== FETCH REQUESTS ===================== */
  const fetchRequests = async () => {
    try {

      const params = new URLSearchParams();

      if (companyCode) {
        params.append("companyCode", companyCode);
      }

      const res = await axiosInstance.get(
        `${URL.GET_REQUESTS}?${params.toString()}`
      );

      if (res.data?.data) {
        setRequests(res.data.data);
      } else {
        setRequests([]);
      }

    } catch (err) {
      console.error(err);
      toast.error("Failed to load requests");
    }
  };

  useEffect(() => {
    fetchRequests();
    fetchBranches();
  }, []);

  /* ===================== FILTER ===================== */
  const filteredRequests = requests.filter((req) => {

    const branchMatch =
      !branchFilter || req.branchCode === Number(branchFilter);

    const statusMatch =
      !statusFilter || req.status === statusFilter;

    const typeMatch =
      !typeFilter || req.requestType === typeFilter;

    return branchMatch && statusMatch && typeMatch;
  });

  /* ===================== PAGINATION ===================== */
  const totalPages = Math.ceil(filteredRequests.length / rowsPerPage);

  const paginatedRequests = filteredRequests.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  /* ===================== APPROVE ===================== */
  const handleApprove = async (requestId, requestType) => {

    try {

      const approveUrl = requestType === "WITHDRAWAL"
        ? `${URL.WITHDRAW_APPROVE}?requestId=${requestId}&approvedBy=${userId}`
        : `${URL.APPROVE_REQUEST}?requestId=${requestId}&approvedBy=${userId}`;

      await axiosInstance.post(approveUrl);

      toast.success("Request approved successfully");

      fetchRequests();

    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Approve failed");
    }
  };

  /* ===================== REJECT ===================== */
  const handleReject = async () => {

    try {

      const rejectUrl = selectedRequestType === "WITHDRAWAL"
        ? `${URL.WITHDRAW_REJECT}?requestId=${selectedRequest}&remarks=${encodeURIComponent(rejectRemarks)}`
        : `${URL.REJECT_REQUEST}?requestId=${selectedRequest}&remarks=${encodeURIComponent(rejectRemarks)}`;

      await axiosInstance.post(rejectUrl);

      toast.success("Request rejected");

      setRejectModal(false);
      setRejectRemarks("");
      setSelectedRequestType(null);

      fetchRequests();

    } catch (err) {
      console.error(err);
      toast.error("Reject failed");
    }
  };

  return (
    <div className="container">

      {/* ===================== HEADER ===================== */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Wallet Requests</h3>
      </div>

      {/* ===================== FILTER ===================== */}
      <div className="card p-3 mb-3">

        <div className="row">

          <div className="col-md-3">
            <label className="form-label">Agency</label>
            <select
              className="form-select form-select-sm"
              value={branchFilter}
              onChange={(e) => setBranchFilter(e.target.value)}
            >
              <option value="">All</option>

              {branchDropdown
                .filter((b) => b.companyCode == companyCode)
                .map((b) => (
                  <option key={b.branchCode} value={b.branchCode}>
                    {b.branchName}
                  </option>
                ))}

            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Type</label>
            <select
              className="form-select form-select-sm"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="TOPUP">Top Up</option>
              <option value="WITHDRAWAL">Withdrawal</option>
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Status</label>
            <select
              className="form-select form-select-sm"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Approved</option>
              <option value="REJECTED">Rejected</option>
            </select>
          </div>

        </div>

      </div>

      {/* ===================== TABLE ===================== */}
     <div className="table-responsive" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
        <table className="table tablestyle table-sm table-bordered table-hover align-middle">

          <thead className="table-dark">
            <tr>
              <th>S.No</th>
              <th>Agency</th>
              <th>Type</th>
              <th>Amount</th>
              <th>UTR No.</th>
              <th>Account Holder Name</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>Requested By</th>
              <th>Created At</th>
              <th>Approved At</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            {paginatedRequests.length > 0 ? (
              paginatedRequests.map((req, index) => (

                <tr key={req.id}>

                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

                  <td>{getBranchName(req.branchCode)}</td>

                  <td>
                    <span
                      className={`badge ${
                        req.requestType === "WITHDRAWAL"
                          ? "bg-warning text-dark"
                          : "bg-info"
                      }`}
                    >
                      {req.requestType || "TOPUP"}
                    </span>
                  </td>

                  <td>₹ {req.requestAmount?.toLocaleString("en-IN")}</td>

                  <td>{req.utrNumber || "-"}</td>

                  <td>{req.accountHolderName || "-"}</td>

                  <td>{req.remarks || "-"}</td>

                  <td>
                    <span
                      className={`badge ${
                        req.status === "APPROVED"
                          ? "bg-success"
                          : req.status === "REJECTED"
                          ? "bg-danger"
                          : "bg-warning"
                      }`}
                    >
                      {req.status}
                    </span>
                  </td>

                  <td>{req.requestedBy}</td>

                  <td>{req.createdAt?.replace("T", " ")}</td>

                  <td>{req.approvedAt ? req.approvedAt.replace("T", " ") : "-"}</td>

                  <td>

                    {req.status === "PENDING" && (

                      <div className="d-flex gap-2">

                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleApprove(req.id, req.requestType)}
                        >
                          Approve
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            setSelectedRequest(req.id);
                            setSelectedRequestType(req.requestType);
                            setRejectModal(true);
                          }}
                        >
                          Reject
                        </button>

                      </div>

                    )}

                  </td>

                </tr>

              ))
            ) : (

              <tr>
                <td colSpan="12" className="text-center text-muted">
                  No requests found
                </td>
              </tr>

            )}

          </tbody>

        </table>

      </div>

      {/* ===================== PAGINATION ===================== */}
      {filteredRequests.length > rowsPerPage && (

        <div className="d-flex justify-content-center mt-3">

          <button
            className="btn btn-sm btn-outline-primary me-2"
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          >
            Prev
          </button>

          <span className="align-self-center">
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="btn btn-sm btn-outline-primary ms-2"
            onClick={() =>
              setCurrentPage((p) => Math.min(p + 1, totalPages))
            }
          >
            Next
          </button>

        </div>

      )}

      {/* ===================== REJECT MODAL ===================== */}
      {rejectModal && (

        <div className="modal show fade d-block">
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Reject Request</h5>
                <button
                  className="btn-close"
                  onClick={() => setRejectModal(false)}
                />
              </div>

              <div className="modal-body">

                <label className="form-label">Remarks</label>

                <textarea
                  className="form-control"
                  rows="3"
                  value={rejectRemarks}
                  onChange={(e) => setRejectRemarks(e.target.value)}
                />

              </div>

              <div className="modal-footer">

                <button
                  className="btn btn-secondary"
                  onClick={() => setRejectModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger"
                  onClick={handleReject}
                >
                  Reject Request
                </button>

              </div>

            </div>
          </div>
        </div>

      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
      />

    </div>
  );
};

export default WalletTopUpRequest;
